<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "LiveRoom",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [
          {
            key: 1,
            value: '等待中',
          }, {
            key: 2,
            value: '录制中',
          }, {
            key: 3,
            value: '录制成功',
          }, {
            key: 0,
            value: '录制失败',
          }
        ],
      },
      ],
      permission: {
        add: 'liveRoom:add',
        update: 'liveRoom:update',
        delete: 'liveRoom:delete',
        deleteBatch: 'liveRoom:deleteBatch'
      },
      url: {
        get: '/liveRoom/listByCondition',
        add: '/liveRoom/add',
        update: '/liveRoom/update',
        delete: '/liveRoom/delete/',
        delete_batch: '/liveRoom/deleteBatch',
        status: '/liveRoom/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      }, {
        field: 'anchorName',
        label: '直播用户',
        show: true,
        width: '',
      }, {
        field: 'liveRoomName',
        label: '直播间名称',
        show: true,
        width: '',
      }, {
        field: 'language',
        label: '直播间语言',
        show: {
          type: 'select',
        },
        selectData: [{
          id: 'cn',
          name: '中文'
        }, {
          id: 'en',
          name: '英文'
        }],
        width: '',
      }, {
        field: 'coverImageUrl',
        label: '直播间封面',
        show: true,
        img: true,
        detail: true,
        width: '',
      }, {
        field: 'status',
        label: '状态',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '录制失败',
            type: 'warning'
          }, {
            key: 1,
            value: '等待中',
            type: 'info'
          }, {
            key: 2,
            value: '录制中',
            type: 'primary'
          }, {
            key: 3,
            value: '录制完成',
            type: 'success'
          }]
        },
        detail: false,
        width: '120',
      },
        {
          field: 'liveRoomUrl',
          label: '直播间URL',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'recordingUrl',
          label: '录屏URL',
          detail: true,
          show: false,
          width: '',
        },
        {
          field: 'audioUrl',
          label: '音频URL',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'douYinProduct',
          label: 'SRT文件URL',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'clipCount',
          label: '片段数量',
          show: true,
          width: '',
        }, {
          field: 'tags',
          label: '标签',
          show: true,
          width: '',
        }, {
          field: 'tagsArray',
          label: '标签数组',
          show: true,
          width: '',
        }, {
          field: 'duration',
          label: '录屏时长',
          show: true,
          width: '',
        }, {
          field: 'liveTime',
          label: '直播时间',
          show: true,
          width: '',
        }, {
          field: 'language',
          label: '直播间语言',
          show: {
            type: 'select',
          },
          selectData: [{
            id: 'cn',
            name: '中文'
          }, {
            id: 'en',
            name: '英文'
          }],
          width: '',
        },
        {
          field: 'mp4TaskId',
          label: 'MP4任务ID',
          show: true,
          width: '',
        }, {
          field: 'mp4FileName',
          label: 'MP4任务文件',
          show: true,
          width: '100',
        }, {
          field: 'mp4BuildStatus',
          label: 'MP4生成状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '未生成',
              type: 'danger'
            }, {
              key: 1,
              value: '生成中',
              type: 'primary'
            }, {
              key: 2,
              value: '成功',
              type: 'success'
            }]
          },
          detail: false,
          width: '100',
        },
        {
          field: 'mp3TaskId',
          label: 'MP3任务ID',
          show: true,
          width: '',
        }, {
          field: 'mp3FileName',
          label: 'MP3任务文件',
          show: true,
          width: '100',
        },
        {
          field: 'mp3BuildStatus',
          label: 'MP3生成状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '未生成',
              type: 'info'
            }, {
              key: 1,
              value: '生成中',
              type: 'primary'
            }, {
              key: 2,
              value: '完成生成',
              type: 'success'
            }, {
              key: 3,
              value: '上传听悟中',
              type: 'warning'
            }, {
              key: 4,
              value: '上传听悟完成',
              type: 'success'
            }, {
              key: 5,
              value: 'MP3任务异常',
              type: 'warning'
            }]
          },
          detail: false,
          width: '120',
        },
        {
          field: 'tingWuTxtUrl',
          label: '听悟文本URL',
          detail: true,
          show: true,
          width: '200',
        }, {
          field: 'chapterQuickFactsUrl',
          label: '听悟章节预览URL',
          detail: true,
          show: true,
          width: '200',
        }, {
          field: 'splitRecording',
          label: '长视频拆分录制状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '未拆分',
              type: 'info'
            }, {
              key: 1,
              value: '拆分录制',
              type: 'success'
            }]
          },
          detail: false,
          width: '120',
        }, {
          field: 'message',
          label: '回调日志',
          show: true,
          width: '',
        }, {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        },],
      operate: [],
      formFields: {
        addTitle: '直播',
        updateTitle: '直播',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'phone',
          label: '用户',
          type: 'input',
          placeholder: '手机号',
          rules: [{message: '手机号', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'coverImageUrl',
          label: '直播间封面',
          type: 'input',
          placeholder: '直播间封面',
          rules: [{message: '请输入直播间封面', trigger: 'blur', required: false}],
          add: false,
          update: true,
        }, {
          field: 'liveRoomName',
          label: '直播间名称',
          type: 'input',
          placeholder: '直播间名称',
          rules: [{message: '请输入直播间名称', trigger: 'blur', required: false}],
          add: false,
          update: true,
        },
          {
            field: 'liveRoomUrl',
            label: '直播间URL',
            type: 'input',
            placeholder: '直播间URL',
            rules: [{message: '请输入直播间URL', trigger: 'blur', required: true}],
            add: true,
            update: true,
          },
          {
            field: 'recordingUrl',
            label: '录屏URL',
            type: 'input',
            placeholder: '录屏URL',
            rules: [{message: '请输入录屏URL', trigger: 'blur', required: false}],
            add: true,
            update: true,
          },
          {
            field: 'audioUrl',
            label: '音频URL',
            type: 'input',
            placeholder: '音频URL',
            rules: [{message: '请输入音频URL', trigger: 'blur', required: false}],
            add: true,
            update: true,
          }, {
            field: 'srtFileUrl',
            label: 'SRT文件URL',
            type: 'input',
            placeholder: 'SRT文件URL',
            rules: [{message: '请输入SRT文件URL', trigger: 'blur', required: false}],
            add: true,
            update: true,
          }, {
            field: 'tags',
            label: '标签',
            type: 'input',
            placeholder: '标签',
            rules: [{message: '请输入标签', trigger: 'blur', required: false}],
            add: true,
            update: true,
          }, {
            field: 'language',
            label: '语言',
            type: 'select',
            selectData: [{
              id: 'cn',
              name: '中文'
            }, {
              id: 'en',
              name: '英文'
            }],
            placeholder: '语言',
            rules: [{message: '请输入语言', trigger: 'blur', required: true}],
            add: true,
            update: true,
          }, {
            field: 'isMonitor',
            label: '监听状态',
            type: 'select',
            selectData: [{
              id: 0,
              name: '不监听'
            }, {
              id: 1,
              name: '监听'
            }],
            placeholder: '监听状态',
            rules: [{message: '请选择监听状态', trigger: 'blur', required: false}],
            add: true,
            update: true,
          }],
      }
    }
  }
}
</script>

<style scoped>

</style>
